import { combineReducers } from 'redux';
import authReducer from './auth';
import codeReducer from './code';
import countryReducer from './country';
import emailReducer from './email';
import organizationReducer from './organization';
import organizationSurveyReducer from './organizationSurvey';
import surveyReducer from './survey';
import userReducer from './user';

export default combineReducers({
  auth: authReducer,
  survey: surveyReducer,
  organization: organizationReducer,
  user: userReducer,
  organizationSurvey: organizationSurveyReducer,
  country: countryReducer,
  code: codeReducer,
  email: emailReducer,
});
